export class discipline {
	constructor(
		public Id: string,
		public discipline: string,
		public status: number
	) { }
}